import Modal from "@/components/modal"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"
import riskFamilyStore from "@/entities/risk-family/model/risk-family.store"
import { RiskFamily } from "@/entities/risk-family/model/risk-family.types"
import EnterCodeWidget from "@/widgets/enter-code.widget"

interface Props {
  family: RiskFamily
  onClose: () => void
  onDelete: () => void
}

export default function RiskFamilyDeleteModal({ family, onClose, onDelete }: Props) {
  const dispatch = useAppDispatch()
  const status = useAppSelector(riskFamilyStore.selectors.status)
  const risks = useAppSelector(physicalRiskStore.selectors.list)
  const risksForFamily = risks.filter((risk) => risk.RiskFamilyId === family.id)

  async function handleDelete() {
    for (const risk of risksForFamily) {
      const updatedRisk = { ...risk, RiskFamilyId: null }
      dispatch(physicalRiskStore.actions.setActive(updatedRisk))
      const response = await dispatch(physicalRiskStore.thunks.updateEntity()).unwrap()
      if (response) {
        dispatch(physicalRiskStore.actions.replace(response))
      }
    }

    await dispatch(riskFamilyStore.thunks.removeEntity(family.id)).unwrap()
    dispatch(riskFamilyStore.actions.setActive(null))
    dispatch(physicalRiskStore.actions.setActive(null))
    onDelete()
  }

  return (
    <Modal onClose={onClose} title={`Supprimer la famille « ${family.name} »`}>
      <p>
        Vous êtes sur le point de supprimer la famille « {family.name} ». Les risques associés passeront en “Autres /
        Non défini”.
      </p>
      <p>
        <b>Cette action est irréversible.</b>
      </p>
      <EnterCodeWidget onCancel={onClose} onNext={handleDelete} status={status} />
    </Modal>
  )
}
